import { useNavigate } from "react-router-dom";
import { APP_VERSION } from "../version";

function Footer({ path }) {
  const navigate = useNavigate();

  const Contact = () => {
    switch (path) {
      case "/":
        return (
          <div className="footer-contact" onClick={() => navigate("/help")}>
            SUPPORT
          </div>
        );
      case "/help":
        return null;

      default:
        return (
          <div className="footer-contact" onClick={() => navigate("/contact")}>
            FEEDBACK
          </div>
        );
    }
  };

  return (
    <div className="footer-bar">
      <div className="footer-copy">
        MATLIB {new Date().getFullYear()}
        <span className="footer-version">V{APP_VERSION}</span>
      </div>
      <Contact />
    </div>
  );
}

export default Footer;
